import { compose } from 'recompose';
import { withPortlet } from 'js/components/system/Portlet';
import { withDetailsContext } from '../withContext';
import { withFetch } from '../withLeaderBoardDetails';
import withDetailsUpdates from './withDetailsUpdates';
import withReducer from './withReducer';

export default compose(
    withPortlet({ forLoggedIn: true }),
    withReducer,
    withDetailsContext,
    withFetch,
    withDetailsUpdates
);
